
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

const Wallets = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-[#F1F0FB] to-white">
      <Header />
      <div className="container mx-auto px-4 py-12">
        <div className="mb-8">
          <Link to="/knowledge-hub/basics">
            <Button variant="ghost" className="flex items-center gap-2 hover:bg-[#9b87f5]/10 hover:text-[#9b87f5]">
              <ArrowLeft className="h-4 w-4" />
              Back to Crypto Basics
            </Button>
          </Link>
        </div>

        <article className="prose prose-slate lg:prose-lg max-w-4xl mx-auto bg-white rounded-2xl shadow-lg p-8 md:p-12">
          <h1 className="text-4xl md:text-5xl font-bold mb-8 text-[#4A607B] text-center !mt-0">
            Understanding Crypto Wallets
          </h1>

          <p className="text-lg text-gray-700 mb-8 text-center max-w-3xl mx-auto">
            A crypto wallet is your gateway to the blockchain, storing the private keys that give you access to your cryptocurrencies and digital assets.
          </p>

          <div className="space-y-12">
            <section>
              <h2 className="text-2xl font-semibold text-[#4A607B] mb-4">What is a Crypto Wallet?</h2>
              <p className="text-gray-700">
                A crypto wallet doesn't actually "store" your cryptocurrency - the crypto exists on the blockchain. Instead, it stores the private keys necessary to access and manage your crypto. Think of it like a key to your safety deposit box rather than the box itself.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-[#4A607B] mb-4">Types of Crypto Wallets</h2>
              
              <h3 className="text-xl font-semibold text-[#4A607B] mt-6 mb-3">Custodial Wallets</h3>
              <p className="text-gray-700 mb-4">Third-party services that hold your private keys.</p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700">
                <li>Pros: Easy to use, convenient for beginners</li>
                <li>Cons: Less control, risk of third-party issues</li>
              </ul>

              <h3 className="text-xl font-semibold text-[#4A607B] mt-6 mb-3">Non-Custodial Wallets</h3>
              <p className="text-gray-700 mb-4">You have complete control over your private keys.</p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700">
                <li>Pros: Full control, greater security</li>
                <li>Cons: More technical knowledge required</li>
              </ul>

              <h3 className="text-xl font-semibold text-[#4A607B] mt-6 mb-3">Hardware Wallets</h3>
              <p className="text-gray-700 mb-4">Physical devices storing keys offline.</p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700">
                <li>Pros: Excellent security, immune to online hacking</li>
                <li>Cons: More expensive, requires technical knowledge</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-[#4A607B] mb-4">Protecting Your Crypto Wallet</h2>
              <ul className="list-disc pl-6 space-y-2 text-gray-700">
                <li>Use strong, unique passwords</li>
                <li>Enable Two-Factor Authentication (2FA)</li>
                <li>Keep software up-to-date</li>
                <li>Be aware of phishing scams</li>
                <li>Create wallet backups</li>
                <li>Store seed phrases securely</li>
              </ul>
            </section>
          </div>
        </article>
      </div>
      <Footer />
    </div>
  );
};

export default Wallets;
